export default __webpack_public_path__ + "static/media/delete_disable.fd2246ae.svg";